<template>
  <div class="home">
    <innerHeader v-if="!isMobile" :ind="2"></innerHeader>
    <AppHeader v-if="isMobile" />
    <ResponsiveContainer>
      <div class="main">
        <contentList
          @tabChagnge="tabChagnge"
          :tabList="tabList"
          :leftTab="4"
          :cloumnId="cloumnId"
          v-if="!isMobile"
          :detailName="detail.title"
          class="bg"
        >
          <div slot="main_content">
            <div class="content_top" v-if="Object.keys(detail).length">
              <div class="article_con">
                <div class="content_item">
                  <div class="content_item_img">
                    <img v-if="detail.coverImg" v-lazy="detail.coverImg" />
                  </div>
                  <div class="content_item_title">
                    <p class="title">{{ detail.title }}</p>
                    <p class="desc">{{ detail.theater }}</p>
                    <p class="desc">{{ detail.artisticForm }}</p>
                    <p class="desc">
                      {{ $t('director') }}&nbsp;&nbsp;{{ detail.director }}
                    </p>
                    <div class="content_item_d">
                      <div class="item_d">
                        <div class="item_d_l">
                          <img src="../../assets/img/time_icon.png" />{{
                            $t('time')
                          }}
                        </div>
                        <div class="item_d_r">
                          {{ detail.performanceTime }}
                        </div>
                      </div>
                      <div class="item_d">
                        <div class="item_d_l">
                          <img src="../../assets/img/site_icon.png" />{{
                            $t('site')
                          }}
                        </div>
                        <div class="item_d_r">{{ detail.site }}</div>
                      </div>
                      <div class="item_d">
                        <div class="item_d_l">
                          <img src="../../assets/img/duration_icon.png" />{{
                            $t('duration')
                          }}
                        </div>
                        <div class="item_d_r">{{ detail.duration }}</div>
                      </div>
                    </div>
                    <div class="perform_type">
                      <span>{{ detail.language }}</span>
                      <!-- <span>波兰语演出</span>
                      <span>|</span>
                      <span>中英文字幕</span> -->
                    </div>
                  </div>
                </div>
                <div class="img_con" v-if="videoList.length">
                  <swiper
                    :options="swiperOptionThree"
                    ref="mySwiperThree"
                    class="ThreeSwiper"
                  >
                    <swiper-slide
                      class="img_slide"
                      v-for="(act, x) in videoList"
                      :key="x"
                    >
                      <div class="img_item">
                        <img :src="act" />
                        <!-- <div class="img_title">{{ act.title }}</div> -->
                      </div>
                    </swiper-slide>
                    <div class="swiper-paginationThree" slot="pagination"></div>
                  </swiper>
                  <div class="swiper-button-prev"></div>
                  <div class="swiper-button-next"></div>
                </div>
                <!-- <div class="img_text" v-if="detail.photographer">
                  摄影师：{{ detail.photographer }}
                </div> -->
                <div class="article_con_d">
                  <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane
                      :label="t.name"
                      :name="t.value"
                      v-for="(t, index) in tabsData"
                      :key="index"
                    ></el-tab-pane>
                  </el-tabs>
                  <div class="tab_con">
                    <div
                      class="tab_item"
                      v-for="(t, index) in tabContent"
                      :key="index"
                      :id="`section${index}`"
                    >
                      <div class="title">
                        <h3>{{ t.title }}</h3>
                        <div class="english">
                          {{ t.english }}
                        </div>
                        <div class="line"></div>
                      </div>
                      <div class="detail_con" v-html="t.content"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="content_top" v-else>
              <el-empty :description="$t('noData')"></el-empty>
            </div>
          </div>
        </contentList>
        <AppcontentList
          :tabList="tabList"
          :leftTab="4"
          :cloumnId="cloumnId"
          v-if="isMobile"
        >
          <div slot="main_content">
            <div class="app_content_top" v-if="Object.keys(detail).length">
              <div class="article_con">
                <div class="content_item_u">
                  <div class="content_item_img">
                    <img v-lazy="detail.coverImg" />
                  </div>
                  <div class="content_item_title">
                    <p class="title">{{ detail.title }}</p>
                    <p class="desc">{{ detail.theater }}</p>
                    <p class="desc">{{ detail.artisticForm }}</p>
                    <p class="desc">
                      {{ $t('director') }}&nbsp;&nbsp;{{ detail.director }}
                    </p>
                    <div class="perform_type">
                      <span>{{ detail.language }}</span>
                      <!-- <span>波兰语演出</span>
                      <span>|</span>
                      <span>中英文字幕</span> -->
                    </div>
                  </div>
                </div>
                <div class="content_item_d">
                  <div class="item_d">
                    <div class="item_d_l">
                      <img src="../../assets/img/time_icon.png" />{{
                        $t('time')
                      }}
                    </div>
                    <div class="item_d_r">
                      {{ detail.performanceTime }}
                    </div>
                  </div>
                  <div class="item_d">
                    <div class="item_d_l">
                      <img src="../../assets/img/site_icon.png" />{{
                        $t('site')
                      }}
                    </div>
                    <div class="item_d_r">{{ detail.site }}</div>
                  </div>
                  <div class="item_d">
                    <div class="item_d_l">
                      <img src="../../assets/img/duration_icon.png" />{{
                        $t('duration')
                      }}
                    </div>
                    <div class="item_d_r">{{ detail.duration }}</div>
                  </div>
                </div>

                <div class="img_con">
                  <swiper
                    :options="swiperOptionThree"
                    ref="mySwiperThree"
                    class="ThreeSwiper"
                    v-if="videoList.length"
                  >
                    <swiper-slide
                      class="img_slide"
                      v-for="(act, x) in videoList"
                      :key="x"
                    >
                      <div class="img_item">
                        <img :src="act" />
                        <!-- <div class="img_title">{{ act.title }}</div> -->
                      </div>
                    </swiper-slide>
                    <div class="swiper-paginationThree" slot="pagination"></div>
                  </swiper>
                  <div class="swiper-button-prev"></div>
                  <div class="swiper-button-next"></div>
                </div>

                <div class="article_con_d">
                  <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane
                      :label="t.name"
                      :name="t.value"
                      v-for="(t, index) in tabsData"
                      :key="index"
                    ></el-tab-pane>
                  </el-tabs>
                  <div class="tab_con">
                    <div
                      class="tab_item"
                      v-for="(t, index) in tabContent"
                      :key="index"
                      :id="`section${index}`"
                    >
                      <div class="title">
                        <h3>{{ t.title }}</h3>
                        <div class="english">
                          {{ t.english }}
                        </div>
                        <div class="line"></div>
                      </div>
                      <div class="app_detail_con" v-html="t.content"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="content_top" v-else>
              <el-empty :description="$t('noData')"></el-empty>
            </div></div
        ></AppcontentList>
      </div>
    </ResponsiveContainer>
    <Footer v-if="!isMobile" />
    <AppFooter v-else />
  </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import innerHeader from '@/components/innerHeader.vue';
import AppHeader from '@/components/AppHeader';
import Footer from '@/components/Footer.vue';
import AppFooter from '@/components/AppFooter';
import ResponsiveContainer from '@/components/ResponsiveContainer';
import contentList from '@/components/contentList';
import AppcontentList from '@/components/AppcontentList';
import paginations from '@/components/Pagination.vue';
import responsiveMixin from '@/mixins/responsiveMixin';
import { themeTab } from '@/const';
import { getObj } from '@/assets/api';
export default {
  name: 'InvitedPlayDetail',
  mixins: [responsiveMixin],
  components: {
    innerHeader,
    AppHeader,
    AppFooter,
    Footer,
    ResponsiveContainer,
    contentList,
    AppcontentList,
    paginations,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      currentIndex: 0,
      tabList: themeTab,
      cloumnId: null, //栏目id
      detail: {},

      swiperOptionThree: {
        // direction:"horizontal",/*横向滑动*/
        spaceBetween: 70,
        //可见图片张数
        slidesPerView: 1, // 显示3张完整图片+第4张的20%
        // loopedSlides: 4,// 在loop模式下使用slidesPerView，还需使用该参数设置所要用到的loop个数(一般设置大于可视slide个数2个即可)
        loopFillGroupWithBlank: true,
        observer: true, // 改变swiper样式时，自动初始化swiper
        observeParents: true, // 监测swiper父元素，如果有变化则初始化swiper
        autoplayDisableOnInteraction: false,
        paginationClickable: true,
        effect: 'coverflow',

        coverflowEffect: {
          rotate: 0,
          stretch: -20, // 负值使两侧图片向内收缩
          depth: 150,
          modifier: 1.2, // 增强透视效果
          slideShadows: false,
        },
        // on: {
        //   init: function () {
        //     console.log(111, this.activeIndex, this.slides);
        //     this.slides.forEach((slide, index) => {
        //       if (index !== this.activeIndex) {
        //         slide.style.opacity = '0.5';
        //         slide.style.transform = 'scale(0.85)';
        //       }
        //     });
        //   },
        //   slideChange: function () {
        //     console.log(2, this.activeIndex);
        //     this.slides.forEach((slide, index) => {
        //       slide.style.opacity = index === this.activeIndex ? '1' : '0.5';
        //       slide.style.transform =
        //         index === this.activeIndex ? 'scale(1)' : 'scale(0.85)';
        //     });
        //   },
        // },
        // 默认选中中间一张
        centeredSlides: true,
        // preventClicks: false,//当swiper在触摸时阻止默认事件（preventDefault），用于防止触摸时触发链接跳转。
        //无限循环
        loop: true,

        //自动轮播
        autoplay: true,
        // pagination:'.swiper-pagination',
        //小圆点（我此处没使用，列出供参考）
        pagination: {
          el: '.swiper-paginationThree',
          type: 'bullets',
          formatFractionCurrent: function (number) {
            return number; // 当前页码
          },
          formatFractionTotal: function (number) {
            return number; // 总页数
          },
        },
        //上下按钮点击轮播效果
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      videoList: [],
      //     performntroduction: '演出介绍',
      // mediaCommentary: '媒体评论',
      // editorIntroduction: '编剧介绍',
      // directorIntroduction: '导演介绍',
      // actorJobSchedule: '演员职表',
      // troupeIntroduction: '剧团介绍',
      tabsData: [
        { name: this.$t('performntroduction'), value: '0' },
        { name: this.$t('mediaCommentary'), value: '1' },
        { name: this.$t('editorIntroduction'), value: '2' },
        { name: this.$t('directorIntroduction'), value: '3' },
        { name: this.$t('actorJobSchedule'), value: '4' },
        { name: this.$t('troupeIntroduction'), value: '5' },
      ],
      activeName: '0',
      tabContent: [
        {
          title: '演出介绍',
          english: 'About the Show',
          content: '',
        },
        {
          title: '媒体评论',
          english: 'Reviews',
          content: '',
        },
        {
          title: '编剧介绍',
          english: 'Introduction to the Screenwriter',
          content: '',
        },
        {
          title: '导演介绍',
          english: 'About the Director',
          content: '',
        },
        {
          title: '演员职表',
          english: 'Credits',
          content: '',
        },
        {
          title: '剧团介绍',
          english: 'About the Theatre Company',
          content: '',
        },
      ],
      id: '',
    };
  },
  mounted() {
    if (this.$route.query) {
      this.id = this.$route.query.id;
      this.cloumnId = this.$route.query.cloumnId || null;
      this.getDetail();
    }
  },
  methods: {
    tabChagnge(column, cloumnId) {
      this.cloumnId = cloumnId;
      this.$router.push({ path: column.accessPath });
      // this.getList();
    },
    handleClick(tab, event) {
      this.$nextTick(() => {
        const element = document.getElementById(`section${tab.index}`);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start', // 对齐到顶部
          });
        }
      });
    },
    currentChange(e) {
      this.current = e;
      // this.getList();
    },
    getDetail() {
      getObj(this.id).then((res) => {
        if (res.code == 200) {
          this.detail = res.data;
          this.videoList = this.detail.img.split(',');
          // 过滤掉内容为空的栏目，同时更新 tabsData
          const filteredTabContent = [];
          const filteredTabsData = [];

          this.tabContent.forEach((t, index) => {
            if (t.title == '演出介绍') {
              t.content = this.detail.content;
            } else if (t.title == '媒体评论') {
              t.content = this.detail.mediaComment;
            } else if (t.title == '编剧介绍') {
              t.content = this.detail.screenIntroduction;
            } else if (t.title == '导演介绍') {
              t.content = this.detail.direcIntroduction;
            } else if (t.title == '演员职表') {
              t.content = this.detail.actorSchedule;
            } else if (t.title == '剧团介绍') {
              t.content = this.detail.troupeIntroduction;
            }

            // 如果内容不为空，则保留该栏目
            if (t.content && t.content.trim() !== '') {
              filteredTabContent.push(t);
              filteredTabsData.push(this.tabsData[index]);
            }
          });

          this.tabContent = filteredTabContent;
          this.tabsData = filteredTabsData;

          console.log('this.tabContent', this.tabContent);
          console.log('this.tabsData', this.tabsData);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.img_text {
  text-align: right;
}
.main {
  .content_top {
    margin: 1.5rem 0 0;
    overflow: hidden;
    .article_con {
      width: 100%;
      box-sizing: border-box;

      .content_item {
        flex: 0 0 calc((100% - 40px) / 3);
        text-align: left;
        margin: 0 0 20px 0;
        overflow: hidden;
        background: rgba(255, 255, 255, 0);
        border: 6px solid rgba(255, 255, 255, 0);
        display: flex;
        align-items: stretch;
        height: 25rem;
        .content_item_img {
          width: 25%;
          height: 100%;
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center; /* 图片的中心与容器的中心对齐 */
          }
        }
        .content_item_title {
          flex: 1;
          padding: 1.25rem 2.5rem;
          background: #fff;
          box-sizing: border-box;
          .title {
            font-size: 2.25rem;
            color: #333;
            display: -webkit-box; /* 旧版 Flex 布局 */
            -webkit-line-clamp: 2; /* 限制行数 */
            -webkit-box-orient: vertical; /* 垂直排列 */
            overflow: hidden; /* 隐藏溢出 */
            text-overflow: ellipsis;
            padding: 0 1.25rem;
          }
          .desc {
            font-size: 1.125rem;
            color: #6b6d7a;
            display: -webkit-box; /* 旧版 Flex 布局 */
            -webkit-line-clamp: 2; /* 限制行数 */
            -webkit-box-orient: vertical; /* 垂直排列 */
            overflow: hidden; /* 隐藏溢出 */
            text-overflow: ellipsis;
            margin: 0.375rem 0;
            padding: 0 1.25rem;
          }
          .content_item_d {
            margin-top: 0.625rem;
            background: #f6f6f6;
            padding: 0.3125rem 0.625rem;
            .item_d {
              display: flex;
              justify-content: flex-start;
              font-size: 1.125rem;
              margin: 0.625rem 0;
              .item_d_l {
                display: flex;
                align-items: center;
                font-family: SourceHanSansCN-Medium;
                img {
                  width: 1.25rem;
                  height: 1.25rem;
                }
              }
              .item_d_r {
                display: inline-block;
                color: #6b6d7a;
                margin-left: 0.3125rem;
              }
            }
          }
          .perform_type {
            display: flex;
            align-items: center;
            margin: 0.5rem;
            span {
              font-size: 0.875rem;
              color: #6b6d7a;
              margin-right: 0.3125rem;
            }
          }
        }
      }
      .img_con {
        position: relative;
        .ThreeSwiper {
          // height: 15.3333rem;
        }
        .img_slide {
          .img_item {
            height: 43.8125rem;
            overflow: hidden;
            position: relative;
            margin-left: 0.5rem;

            img {
              width: 100%;
              height: 43.8125rem;
              object-fit: cover;
              object-position: center; /* 图片的中心与容器的中心对齐 */
              position: relative;
            }

            .img_title {
              width: 100%;
              position: absolute;
              z-index: 5;
              bottom: 0;
              left: 0;
              height: 5rem;
              line-height: 5rem;
              width: 100%;
              padding: 0 2.375rem;
              background: linear-gradient(
                180deg,
                rgba(0, 0, 0, 0) 0%,
                rgba(0, 0, 0, 0.5) 100%
              ); /* 半透明背景增强效果 */
              color: #fff;
              text-align: left;
              box-sizing: border-box;
              font-size: 1.75rem;
            }
          }
        }
        .swiper-paginationThree {
          position: absolute;
          bottom: 0;
          left: 48%;
          z-index: 999;

          ::v-deep {
            .swiper-pagination-bullet {
              background: #c2c4ce;
              margin-left: 0.3125rem;
              border-radius: 0;
              width: 0.75rem;
              height: 0.75rem;
            }
            .swiper-pagination-bullet-active {
              background: #1d1d1d !important;
              transform: rotate(45deg); /* 旋转 + 放大 */
            }
          }
        }
      }

      .article_con_d {
        margin-top: 3.75rem;
        .tab_con {
          .tab_item {
            margin: 3.75rem 0;
            .title {
              display: flex;
              justify-content: space-between;
              align-items: center;
              h3 {
                color: #424451;
                font-size: 2.25rem;
              }
              .english {
                color: #c2c4ce;
                font-size: 1.5rem;
                margin: 0 1.5rem;
                text-transform: uppercase; /* 强制转为大写 */
              }
              .line {
                flex: 1;
                height: 0.0625rem;
                background: #dadbdf;
              }
            }
          }
        }
      }
    }
  }
  .app_content_con {
    background: #fff;
  }
  .app_content_top {
    background: #fff;
    margin: 2rem 0;
    .article_con {
      background: #fff;
      width: 100%;
      box-sizing: border-box;

      .content_item_u {
        display: flex;
        background: #f0f1f2;
        align-items: stretch;
        overflow: hidden;
        min-height: 8.3333rem; /* 可选：设置最小高度，防止内容过少时塌陷 */
        .content_item_img {
          width: 27.8%;
          min-height: inherit; /* 确保继承最小高度 */
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center; /* 图片的中心与容器的中心对齐 */
          }
        }
        .content_item_title {
          flex: 1;
          padding: 1rem 0.3125rem 0.3125rem;
          background: #f0f1f2;
          .title {
            font-size: 1.1667rem;
            color: #333;
            display: -webkit-box; /* 旧版 Flex 布局 */
            -webkit-line-clamp: 2; /* 限制行数 */
            -webkit-box-orient: vertical; /* 垂直排列 */
            overflow: hidden; /* 隐藏溢出 */
            text-overflow: ellipsis;
            padding: 0 1.25rem;
          }
          .desc {
            font-size: 0.8333rem;
            color: #6b6d7a;
            display: -webkit-box; /* 旧版 Flex 布局 */
            -webkit-line-clamp: 2; /* 限制行数 */
            -webkit-box-orient: vertical; /* 垂直排列 */
            overflow: hidden; /* 隐藏溢出 */
            text-overflow: ellipsis;
            margin: 0.375rem 0;
            padding: 0 1.25rem;
          }
          .perform_type {
            display: flex;
            align-items: center;
            margin: 0.375rem 0;
            padding: 0 1.25rem;
            span {
              font-size: 0.8333rem;
              color: #6b6d7a;
              margin-right: 0.3125rem;
            }
          }
        }
      }

      .content_item_d {
        margin-top: 0.625rem;
        padding: 0.3125rem 0.625rem;
        .item_d {
          display: flex;
          justify-content: flex-start;
          font-size: 0.8333rem;
          margin: 0.3125rem 0;
          .item_d_l {
            display: flex;
            align-items: center;
            font-family: SourceHanSansCN-Medium;
            img {
              width: 1.25rem;
              height: 1.25rem;
            }
          }
          .item_d_r {
            display: inline-block;
            color: #6b6d7a;
            margin-left: 0.3125rem;
          }
        }
      }

      .img_con {
        margin-top: 1.6667rem;
        position: relative;
        .ThreeSwiper {
          // height: 15.3333rem;
        }
        .img_slide {
          .img_item {
            height: 18.25rem;
            overflow: hidden;
            position: relative;
            margin-left: 0.5rem;

            img {
              width: 100%;
              height: 18.25rem;
              object-fit: cover;
              object-position: center; /* 图片的中心与容器的中心对齐 */
              position: relative;
            }

            .img_title {
              width: 100%;
              position: absolute;
              z-index: 5;
              bottom: 0;
              left: 0;
              height: 5rem;
              line-height: 5rem;
              width: 100%;
              padding: 0 2.375rem;
              background: linear-gradient(
                180deg,
                rgba(0, 0, 0, 0) 0%,
                rgba(0, 0, 0, 0.5) 100%
              ); /* 半透明背景增强效果 */
              color: #fff;
              text-align: left;
              box-sizing: border-box;
              font-size: 1.75rem;
            }
          }
        }
        .swiper-paginationThree {
          position: absolute;
          bottom: 0;
          left: 48%;
          z-index: 999;

          ::v-deep {
            .swiper-pagination-bullet {
              background: #c2c4ce;
              margin-left: 0.3125rem;
              border-radius: 0;
              width: 0.75rem;
              height: 0.75rem;
            }
            .swiper-pagination-bullet-active {
              background: #1d1d1d !important;
              transform: rotate(45deg); /* 旋转 + 放大 */
            }
          }
        }
      }
      .article_con_d {
        margin-top: 1.6667rem;
        .tab_con {
          .tab_item {
            margin: 2.6667rem 0 1.6667rem;
            .title {
              display: flex;
              justify-content: space-between;
              align-items: center;
              h3 {
                color: #424451;
                font-size: 1.3333rem;
              }
              .english {
                color: #c2c4ce;
                font-size: 0.8333rem;
                margin: 0 1.5rem;
                text-transform: uppercase; /* 强制转为大写 */
              }
              .line {
                flex: 1;
                height: 0.0625rem;
                background: #dadbdf;
              }
            }
          }
        }
      }
    }
  }
}
.content_top {
  .swiper-button-next,
  .swiper-button-prev {
    width: 48px;
    height: 96px;
    /* background-color: rgba(255, 255, 255, 0.2); */
    position: absolute;
    top: 50%;
    transform: translateY(-48px);
  }
}
.app_content_top {
  .swiper-button-next,
  .swiper-button-prev {
    width: 1.5rem;
    height: 3rem;
    /* background-color: rgba(255, 255, 255, 0.2); */
    position: absolute;
    top: 50%;
  }
}

.swiper-button-next {
  right: 0%;
  background-image: url('../../assets/img/homeimgs/y@2x.png') !important;
  background-size: 100% 100%;
  cursor: pointer;
}

.swiper-button-prev {
  left: 0%;
  background-size: 100% 100%;
  background-image: url('../../assets/img/homeimgs/z@2x.png') !important;
  cursor: pointer;
}
::v-deep {
  .article_con_in {
    img {
      width: 100% !important;
      height: auto;
    }
  }

  .content_top {
    .el-tabs__item.is-active {
      color: #2a2a2a;
      font-family: SourceHanSansCN-Medium;
      font-size: 1.5rem;
    }
    .el-tabs__item {
      color: #6b6d7a;
      font-size: 1.5rem;
      height: 3.75rem;
    }
    .el-tabs__nav-wrap::after {
      height: 0.5rem;
      background-color: #eaeaea;
    }
    .el-tabs__active-bar {
      height: 0.5rem;
      background-color: #2a2a2a;
      border-radius: 100px;
    }
  }
  .app_content_top {
    .el-tabs__item.is-active {
      color: #2a2a2a;
      font-family: SourceHanSansCN-Medium;
      font-size: 1.1667rem;
    }
    .el-tabs__item {
      color: #6b6d7a;
      font-size: 1.1667rem;
      height: 3.75rem;
    }
    .el-tabs__nav-wrap::after {
      height: 0.5rem;
      background-color: #eaeaea;
    }
    .el-tabs__active-bar {
      height: 0.5rem;
      background-color: #2a2a2a;
      border-radius: 100px;
    }
  }
}

.bg {
  width: 100%;

  // background: url('../../assets/img/homeimgs/presi_bg.png') no-repeat left
  //   bottom/100% auto;
  background: url('../../assets/img/homeimgs/presi_bg.png') no-repeat center
    center fixed;
  background-size: cover;
}
</style>
